import { render, staticRenderFns } from "./SettingTooltip.vue?vue&type=template&id=d7a819a6&"
import script from "./SettingTooltip.vue?vue&type=script&lang=js&"
export * from "./SettingTooltip.vue?vue&type=script&lang=js&"
import style0 from "./SettingTooltip.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
